import { render } from "./PhotoReview.vue?vue&type=template&id=7f70287c&scoped=true"
import script from "./PhotoReview.vue?vue&type=script&lang=js"
export * from "./PhotoReview.vue?vue&type=script&lang=js"

import "./PhotoReview.vue?vue&type=style&index=0&id=7f70287c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f70287c"]])

export default __exports__